// Website: https://front.com/product/live-chat
// Documentation: https://help.front.com/

import waitForLoad from "../utils/waitForLoad";
var domain = 'https://chat-assets.frontapp.com';
/* eslint-disable */
var loadScript = function loadScript(onload) {
  if (window.FrontChat) return false;
  var script = function script() {
    var _x$parentNode;
    var s = document.createElement('script');
    s.type = 'text/javascript';
    s.async = true;
    s.id = 'front-chat-script';
    s.src = "".concat(domain, "/v1/chat.bundle.js");
    var x = document.getElementsByTagName('script')[0];
    (_x$parentNode = x.parentNode) === null || _x$parentNode === void 0 || _x$parentNode.insertBefore(s, x);
    s.onload = onload;
  };
  script();
  return true;
};
/* eslint-enable */

var load = function load(_ref) {
  var providerKey = _ref.providerKey,
    setState = _ref.setState,
    _ref$beforeInit = _ref.beforeInit,
    beforeInit = _ref$beforeInit === void 0 ? function () {
      return undefined;
    } : _ref$beforeInit,
    _ref$onReady = _ref.onReady,
    onReady = _ref$onReady === void 0 ? function () {
      return undefined;
    } : _ref$onReady;
  var loaded = loadScript(function () {
    var _window$FrontChat, _window;
    beforeInit();
    (_window$FrontChat = (_window = window).FrontChat) === null || _window$FrontChat === void 0 || _window$FrontChat.call(_window, 'init', {
      chatId: providerKey,
      onInitCompleted: function onInitCompleted() {
        setState('complete');
        onReady();
        if (window.FrontChat) window.FrontChat.hasInitialized = true;
      }
      //Read more: https://dev.frontapp.com/docs/chat-sdk-reference
    });
  });
  return loaded;
};
var open = function open() {
  waitForLoad(function () {
    var _window$FrontChat2;
    return !!((_window$FrontChat2 = window.FrontChat) !== null && _window$FrontChat2 !== void 0 && _window$FrontChat2.hasInitialized);
  }, function () {
    var _window$FrontChat3, _window2;
    return (_window$FrontChat3 = (_window2 = window).FrontChat) === null || _window$FrontChat3 === void 0 ? void 0 : _window$FrontChat3.call(_window2, 'show');
  });
};
export default {
  domain: domain,
  load: load,
  open: open
};